import type { PanelEvent, PageContent } from "../content/index.js";

type Tone = "live" | "scheduled" | "ended";

interface RowProps {
  readonly thumb: string;
  readonly event: PanelEvent;
  readonly status: string;
  readonly tone: Tone;
  readonly remaining?: string;
}

function Row({ thumb, event, status, tone, remaining }: RowProps) {
  return (
    <div class="panel-row">
      <img
        class="panel-thumb"
        src={`/assets/panel/${thumb}.webp`}
        alt=""
        width={56}
        height={56}
        loading="lazy"
      />
      <div class="panel-text">
        <span class="panel-name">{event.name}</span>
        <span class={`panel-chip is-${tone}`}>{status}</span>
        <span class="panel-meta is-long">{event.meta}</span>
        <span class="panel-meta is-short">{event.short}</span>
      </div>
      {remaining ? <span class="panel-ring">{remaining}</span> : null}
    </div>
  );
}

export interface OrganizerPanelProps {
  readonly content: PageContent;
}

export function OrganizerPanel({ content }: OrganizerPanelProps) {
  const panel = content.panel;
  const { events, status, groups } = panel;
  return (
    <div class="panel" role="img" aria-label={panel.label}>
      <div class="panel-head" aria-hidden="true">
        <span class="panel-title">{panel.title}</span>
        <span class="panel-new">{panel.newEvent}</span>
      </div>
      <div class="panel-body" aria-hidden="true">
        <div class="panel-rail">
          <span class="is-current">{panel.rail[0]}</span>
          <span>{panel.rail[1]}</span>
        </div>
        <div class="panel-list">
          <p class="panel-group">{groups.live}</p>
          <Row
            thumb="casamento"
            event={events.wedding}
            status={status.live}
            tone="live"
            remaining={panel.remaining}
          />
          <p class="panel-group">{groups.upcoming}</p>
          <div class="panel-stack">
            <Row
              thumb="formatura"
              event={events.graduation}
              status={status.scheduled}
              tone="scheduled"
            />
            <Row
              thumb="confraternizacao"
              event={events.company}
              status={status.scheduled}
              tone="scheduled"
            />
          </div>
          <p class="panel-group">{groups.ended}</p>
          <Row thumb="aniversario" event={events.birthday} status={status.ended} tone="ended" />
        </div>
      </div>
    </div>
  );
}
